import { registerView, ViewComponent } from "@frui.ts/views";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import { observer } from "mobx-react-lite";
import React from "react";
import { Jumbotron } from "react-bootstrap";
import DocumentsUploadedViewModel from "viewModels/notice/components/documentsUploadedViewModel";
import Toolbox from "./toolbox";

const DocumentsUploadedView: ViewComponent<DocumentsUploadedViewModel> = observer(({ vm }) => {
  return (
    <Jumbotron className="col-10 p-7 text-center">
      <div className="px-md-7 mx-md-7 my-4">
        <Icon icon={IconType.CircleCheck} width={61} height={61} className="mb-3 text-success" />
        <h3 className="px-lg-3">{vm.title}</h3>
        <span>{vm.description}</span>
      </div>
      <Toolbox vm={vm} />
    </Jumbotron>
  );
});

registerView(DocumentsUploadedView, DocumentsUploadedViewModel);
